import React from "react";
import "../Skeleton/Skeleton.scss";
import "./HeaderSkeleton.scss";

function HeaderSkeleton() {
  return (
    <nav
      className="header-skeleton"
      aria-busy="true"
      aria-label="Loading navigation"
    >
      <div className="header-skeleton__mobile">
        <div className="header-skeleton__mobile-icon skeleton-shimmer" />
        <div className="header-skeleton__mobile-logo skeleton-shimmer" />
        <div className="header-skeleton__mobile-icon skeleton-shimmer" />
      </div>

      <div className="header-skeleton__desktop">
        <div className="header-skeleton__desktop-upper">
          <div className="header-skeleton__desktop-side skeleton-shimmer" />
          <div className="header-skeleton__desktop-logo skeleton-shimmer" />
          <div className="header-skeleton__desktop-contacts">
            <div className="header-skeleton__desktop-line skeleton-shimmer" />
            <div className="header-skeleton__desktop-line skeleton-shimmer" />
          </div>
        </div>
        <div className="header-skeleton__desktop-links">
          {Array.from({ length: 8 }, (_, i) => (
            <div
              key={i}
              className="header-skeleton__desktop-pill skeleton-shimmer"
            />
          ))}
        </div>
      </div>
    </nav>
  );
}

export default HeaderSkeleton;
